import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SpinInput_InputAdapter_instance2cydgei3k7pxi as SpinInput_InputAdapter_instance } from '../type/adapter/SpinInput_InputAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SpinMutation_VariablesAdapterClass;
function SpinMutation_VariablesAdapter() {
  if (SpinMutation_VariablesAdapterClass === VOID) {
    class $ {
      n6i(writer, value, customScalarAdapters, withDefaultValues) {
        writer.h48('input');
        obj(SpinInput_InputAdapter_instance).f40(writer, customScalarAdapters, value.m6i_1);
      }
    }
    initMetadataForObject($, 'SpinMutation_VariablesAdapter');
    SpinMutation_VariablesAdapterClass = $;
  }
  return SpinMutation_VariablesAdapterClass;
}
var SpinMutation_VariablesAdapter_instance;
function SpinMutation_VariablesAdapter_getInstance() {
  return SpinMutation_VariablesAdapter_instance;
}
//region block: init
SpinMutation_VariablesAdapter_instance = new (SpinMutation_VariablesAdapter())();
//endregion
//region block: exports
export {
  SpinMutation_VariablesAdapter_instance as SpinMutation_VariablesAdapter_instance2vqhdncm9464h,
};
//endregion

//# sourceMappingURL=SpinMutation_VariablesAdapter.mjs.map
